import React, { useState, useEffect } from 'react';
import { Formik } from "formik";
import { Form, Row, Col,Button } from "react-bootstrap";
import "../../../../assets/css/cms/poll.css"
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import Alert from "@mui/material/Alert";
import { useSelector, useDispatch } from 'react-redux';
import Select from "react-select";
import { FiChevronRight } from "react-icons/fi";
import { CUSTOM_STYLE_PERMISSION_DATA_TABLE } from "../../../../constants/cms";
import { RiEdit2Line, RiDeleteBinLine } from "react-icons/ri";
import {
  getPollFilterTitleAction, getPollFilterStatusAction, getPollFilterDeviceAction, getPollFilterPageTypeAction, getPollFilterEntityTypeAction,
  getPollFilterEntityNameAction, getPollsListAction
} from "../../../../../store/actions/cms/pollAction";
// mandatory date imports
import { formatDateFor } from "../../../../utils/index";
import DesktopDatePicker from "@mui/lab/DatePicker";
import AdapterDateFns from '@mui/lab/AdapterDateFns'
import LocalizationProvider from '@mui/lab/LocalizationProvider'
import Box from '@mui/material/Box'
import { format } from 'date-fns';
import { ConfirmDelete } from './confirmDelete';
import Tooltip from "@mui/material/Tooltip";
import {clearMessage} from "../../../../../store/slices/pollSlice";

export const PollsListing = () => {
  const Filter_Data = { "page_type": [{ "id": "article", "value": "article" }, { "id": "college", "value": "college" }, { "id": "homepage", "value": "homepage" }] }
  const data = { polls: { total: '200', published: '120', ongoing: '80' }, table_data: [{ id: 1, entity_type: 'example.com', domain: 'engeneering', url: 'https://www.careers360.com' }] };
  const [tableData, setTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [tableCustomData, setTableCustomData] = useState([])
  const [perPage, setPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const dispatch = useDispatch();
  const [debounceState, setDebounceState] = useState(false)
  const [formikValues, setFormikValues] = useState({})
  const [itemToDelete, setItemToDelete] = useState(null)
  const [open, setOpen] = useState(false);
  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const {
    pollTitleFilterData, pollStatusFilterData, pollDeviceFilterData, pollsListData,deletePollsError,deletePollsDataSuccess,
    pollPageTypeFilterData, pollEntityTypeFilterData, pollEntityNameFilterData, pollsListLoading,message
  } = useSelector((state) => state?.pollCreationReducer)

  useEffect(() => {
    dispatch(getPollFilterTitleAction({filter_type:"poll_title"}));
    dispatch(getPollFilterStatusAction({ filter_type: "status" }))
    dispatch(getPollFilterDeviceAction({ filter_type: "device_type" }))
    dispatch(getPollFilterPageTypeAction({ filter_type: "page_type" }))
  }, [])

  useEffect(() => {
    if (pollsListData) {
      setTableData(pollsListData?.results);
      setTotalRows(pollsListData?.totalRows);
    }
  }, [pollsListData])
  useEffect(() => {
    // Check if all values are null or undefined
    // const isValuesEmpty = Object.values(values).every((item) => item === null || item === undefined);
    const isFormikValuesEmpty = Object.values(formikValues)?.every((item) => item === null || item === undefined);
    const isFiltersEmpty = isFormikValuesEmpty && !dateFrom && !dateTo;
    if(isFiltersEmpty){
      dispatch(getPollsListAction());
    }
  }, [formikValues,dateFrom,dateTo])
  

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    let params = {};
    params.page = page;
    params.itemsOnPage = newPerPage;
    params.poll_title = formikValues?.polls_title?.value;
    params.status = formikValues?.status?.id;
    params.device_type = formikValues?.device_type?.id;
    params.page_type = formikValues?.page_type?.id;
    params.entity_type = formikValues?.entity_type?.id;
    params.entity_name = formikValues?.entity_name?.id;
    if (dateFrom) params.start_date = format(new Date(dateFrom), 'yyyy-MM-dd');
    if (dateTo) params.end_date = format(new Date(dateTo), 'yyyy-MM-dd');
    dispatch(getPollsListAction(params));
    setPerPage(newPerPage);
  };

  useEffect(() => {
    if (currentPage) {
      let params = {};
      params.page = currentPage;
      params.itemsOnPage = perPage;
      params.poll_title = formikValues?.polls_title?.value;
      params.status = formikValues?.status?.id;
      params.device_type = formikValues?.device_type?.id;
      params.page_type = formikValues?.page_type?.id;
      params.entity_type = formikValues?.entity_type?.id;
      params.entity_name = formikValues?.entity_name?.id;
      if (dateFrom) params.start_date = format(new Date(dateFrom), 'yyyy-MM-dd');
      if (dateTo) params.end_date = format(new Date(dateTo), 'yyyy-MM-dd');
      // dispatching list API
      dispatch(getPollsListAction(params))

      setTableCustomData([
        {
          name: "ID",
          selector: (row) => row.id,
        },
        {
          name: "Title",
          selector: (row) => row.title,
          width: "300px",
          cell: (row) => (
            <Tooltip
              title={row.title.length > 30 ? row.title : ""}
              arrow
              placement="top"
            >
              <span>
                {row.title.length > 30 ? `${row.title.substring(0, 30)}...` : row.title}
              </span>
            </Tooltip>
          ),
        },
        {
          name: "Publishing status",
          selector: (row) => row.status,
          cell:(row)=>(
            <button onClick={() => {
              setOpen({"status":row.status, "id":row.id});
            }}
            style={{
              cursor: "pointer",
              outline: "none",
              color: "blue",
              background: "none",
              border: "none"
            }}>{row.status}</button>
          )
        },
        {
          name: "Start Date - End Date",
          selector: (row) => `${formatDateFor(row.start_date)} - ${formatDateFor(row.end_date)}`,
        },
        {
          name: "Page Type",
          selector: (row) => row.page_type,
        },
        {
          name: "Action",
          selector: (row) => row.action,
          cell: (row, index, column, id) => (
            <div>
              <a href={`/cms/polls/manage-polls/${row.id}`}>
                {" "}
                <span className={"icon_edit"}>
                  <RiEdit2Line />
                </span>
              </a>
              <span
                className={"icon_delete"}
                onClick={() => {
                  setOpen({"delete":row.id , "id":row.id});
                }}
              >
                <RiDeleteBinLine />
              </span>
            </div>
          ),
          allowOverflow: true,
          center: "true",
        },
      ]);
    }
  }, [currentPage]);

  useEffect(() => {
      if (message) {
        let params = {};
        params.page = currentPage;
        params.itemsOnPage = perPage;
        params.poll_title = formikValues?.polls_title?.value;
        params.status = formikValues?.status?.id;
        params.device_type = formikValues?.device_type?.id;
        params.page_type = formikValues?.page_type?.id;
        params.entity_type = formikValues?.entity_type?.id;
        params.entity_name = formikValues?.entity_name?.id;
        if (dateFrom) params.start_date = format(new Date(dateFrom), 'yyyy-MM-dd');
        if (dateTo) params.end_date = format(new Date(dateTo), 'yyyy-MM-dd');
        setTimeout(() => {
          if((deletePollsError) && message){
              dispatch(clearMessage());
          }else{
              dispatch(clearMessage());
              dispatch(getPollsListAction(params));
          }
        }, 3000);
      }
    }, [message]);
  return (
    <>
      <h4>Poll Management</h4>

      {/* breadcrumb */}
      <div className={"custom_breadcrumb"}>
        <ul className={"custom_breadcrumb_ul"}>
          <li className={"custom_breadcrumb_list"}>
            <Link to="/cms/">
              <a className={"sub_nan_anchor"}>Home</a>
            </Link>
          </li>
          <li className={"custom_breadcrumb_list"}>
            <span>
              <FiChevronRight />
            </span>
          </li>
          <li className={`${"custom_breadcrumb_list"} ${"custom_breadcrumb_list_active"}`}>
            Manage Poll
          </li>
        </ul>
      </div>

    {/* Alert Show */}
    <div className={"notification_popup"}>
        {message && (
        <Alert severity={deletePollsError ? `error` : `success`}>
            {" "}
            {message?.message ? JSON.stringify(message?.message) : JSON.stringify(message) }
        </Alert>
        )}
      </div>

      {/* Counter Cards */}

      <div className={"examfilter"}>
        <Row className='mb-5  d-flex justify-content-between' style={{gap:'12px'}}>
          <Col md={3} className='d-flex flex-column justify-content-center align-items-center'  style={{minWidth:'450px', height: '160px', padding: '20px 40px', backgroundColor: '#fff', fontSize:'20px',borderRadius:'8px',boxShadow: 'rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px'}}>
            <span className='d-block'>{pollsListData?.stats?.total_polls}</span>
            <span>Total Polls</span>
          </Col>
          <Col md={3} className='d-flex flex-column justify-content-center align-items-center' style={{minWidth:'450px', height: '160px', padding: '20px 40px', backgroundColor: '#fff',fontSize:'20px',borderRadius:'8px', boxShadow: 'rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px'}}>
            <span className='d-block'>{pollsListData?.stats?.published_polls}</span>
            <span>Published Polls</span>
          </Col>
          <Col md={3} className='d-flex flex-column justify-content-center align-items-center' style={{minWidth:'450px', height: '160px', padding: '20px 40px', backgroundColor: '#fff',fontSize:'20px',borderRadius:'8px',boxShadow: 'rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px' }}>
            <span className='d-block'>{pollsListData?.stats?.ongoing_polls}</span>
            <span>Ongoing Polls</span>
          </Col>
        </Row>


        <h3 className='mt-2 mb-3'>Filter Poll List</h3>

        {/* filter form */}

        <Formik
          initialValues={{}}
          enableReinitialize
          validate={(values) => {
            const errors = {};

            return errors;
          }}
          onSubmit={(values) => {
            // submit(values);
          }}
        >
          {({
            values,
            handleSubmit,
            setFieldValue,
            resetForm,
          }) => {

            const handleSearchTitle = (query) => {
              let inDebounce = debounceState;
              clearTimeout(inDebounce);
              inDebounce = setTimeout(() => {
                if(typeof query ==='string' && query?.length>1)
                    dispatch(getPollFilterTitleAction({ filter_type: "poll_title", term: query }));
              }, 1000);
              setDebounceState(inDebounce);
            }
            const handleSearchEntityName = (query) =>{
              let entityType= values?.page_type?.id === 'college_detail_pages'
                              ? 'college': values?.entity_type 
                              ? values?.entity_type?.id : values?.page_type?.entity_type ? values?.page_type?.entity_type: values?.page_type?.id;
              let params ={
                'filter_type':'entity_name',
                'page_type':values?.page_type?.id,
                'entity_type':entityType,
                'term':query
              }
              let inDebounce = debounceState;
              clearTimeout(inDebounce);
              inDebounce = setTimeout(() => {
                dispatch(getPollFilterEntityNameAction(params));
              }, 1000);
              setDebounceState(inDebounce);
            }

            const handleOnChange = (field, obj) => {
              setFieldValue(field, obj);

              // Update formikValues after setting the field value
              const updatedValues = { ...values, [field]: obj };

              if (field == "page_type") {
                let params={};
                setFieldValue('entity_type', null);
                setFieldValue('entity_name', null);
                updatedValues.entity_type = null;
                updatedValues.entity_name = null;

                params.entity_type = obj?.entity_type ? obj?.entity_type : obj?.id;
                if (obj?.value !== 'Articles' && obj?.value !== 'News') {
                  if(obj?.value ==='College Detail Pages') params.entity_type='college'
                  dispatch(getPollFilterEntityNameAction({ filter_type: 'entity_name', page_type: obj?.id, ...params}))
                } else
                    dispatch(getPollFilterEntityTypeAction({ filter_type: 'entity_type', page_type: obj?.id }))
              }
              if (field == "entity_type") {
                  dispatch(getPollFilterEntityNameAction({ filter_type: 'entity_name', entity_type: obj?.id, page_type:values?.page_type?.id}))
              }
              setFormikValues(updatedValues);

            }

            const handleSearch = () => {
              setFormikValues(values)
              let params = {};
              params.page = currentPage;
              params.itemsOnPage = perPage;
              params.poll_title = values?.polls_title?.value;
              params.status = values?.status?.id;
              params.device_type = values?.device_type?.id;
              params.page_type = values?.page_type?.id;
              params.entity_type = values?.entity_type?.id;
              params.entity_name = values?.entity_name?.id;
              if (dateFrom) params.start_date = format(new Date(dateFrom), 'yyyy-MM-dd');
              if (dateTo) params.end_date = format(new Date(dateTo), 'yyyy-MM-dd');
              setCurrentPage(1); // Reset to page 1
              setResetPaginationToggle(!resetPaginationToggle); // Toggle to reset pagination
              // if(!Object.keys(values)?.length !=0 || dateFrom !=null || dateTo!=null)
                dispatch(getPollsListAction(params))
            }

            const clearFilter = ()=>{
              setFormikValues({});
              setFieldValue("polls_title", null); // Explicitly reset Select fields
              setFieldValue("status", null);
              setFieldValue("device_type", null);
              setFieldValue("page_type", null);
              setFieldValue("entity_type", null);
              setFieldValue("entity_name", null);
              setDateFrom(null); // Reset date fields
              setDateTo(null);
            }
            const handleClear = () => {
              resetForm();
              clearFilter();
              dispatch(getPollsListAction({ page: 1, itemsOnPage:perPage }));
              dispatch(getPollFilterTitleAction({filter_type:"poll_title"}));
            }

            const isSearchDisabled = !values.polls_title &&
                         !values.status &&
                         !values.device_type &&
                         !values.page_type &&
                         !values.entity_type &&
                         !values.entity_name &&
                         !dateFrom &&
                         !dateTo;
          


            return (
              <Form onSubmit={handleSubmit}>
                <Row>
                  <Col md={4} className='mb-4'>
                    <Form.Group>
                      <Form.Label>Search By Title </Form.Label>
                      <Select
                        placeholder="Search & select..."
                        name="polls_title"
                        isClearable={true}
                        isSearchable={true}
                        options={pollTitleFilterData?.poll_titles}
                        getOptionLabel={(option) => option["value"]}
                        getOptionValue={(option) => option["id"]}
                        onChange={(obj) => handleOnChange("polls_title", obj)}
                        onInputChange={(query) => handleSearchTitle(query)}
                        value={values?.polls_title || null} 
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4} className='mb-4'>
                    <Form.Group>
                      <Form.Label>Filter By Publishing Status </Form.Label>
                      <Select
                        placeholder="Select..."
                        name="status"
                        isClearable={true}
                        isSearchable={true}
                        options={pollStatusFilterData?.status}
                        getOptionLabel={(option) => option["value"]}
                        getOptionValue={(option) => option["id"]}
                        onChange={(obj) => handleOnChange("status", obj)}
                        value={values?.status || null} 

                      />
                    </Form.Group>
                  </Col>
                  <Col md={4} className='mb-4'>
                    <Form.Group>
                      <Form.Label>Filter By device </Form.Label>
                      <Select
                        placeholder="Select..."
                        name="device_type"
                        isClearable={true}
                        isSearchable={true}
                        options={pollDeviceFilterData?.device_type}
                        getOptionLabel={(option) => option["value"]}
                        getOptionValue={(option) => option["id"]}
                        onChange={(obj) => handleOnChange("device_type", obj)}
                        value={values?.device_type || null} 
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4} className='mb-4'>
                    <Form.Group className="mb-3 date_input" controlId="startDate">
                      <Form.Label>Filter By Start Date</Form.Label>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DesktopDatePicker
                          label="Custom input"
                          value={dateFrom}
                          // maxDate={(dateTo!=null && dateTo!=undefined) &&  new Date(dateTo)}
                          onChange={(sValue) => {
                            if (sValue) setDateFrom(sValue.toISOString());
                            else setDateFrom(null);
                          }}
                          renderInput={({ inputRef, inputProps, InputProps,
                          }) => (
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                              <Form.Control
                                ref={inputRef}
                                {...inputProps}
                                className={"input_pd"}
                                placeholder='dd-mm-yyyy'
                                value={dateFrom ? format(new Date(dateFrom), 'dd-MM-yyyy') : ''}
                              />
                              {InputProps?.endAdornment}
                              {dateFrom && (
                                <Button variant="link" onClick={() => setDateFrom(null)} className={"cross-button position-absolute"}>
                                  &#x2716;
                                </Button>
                              )}
                            </Box>
                          )}
                        />
                      </LocalizationProvider>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3 date_input" controlId="startDate">
                      <Form.Label>Filter By End date</Form.Label>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DesktopDatePicker
                          label="Custom input"
                          value={dateTo}
                          minDate={dateFrom && new Date(dateFrom)}
                          onChange={(eValue) => {
                            setDateTo(eValue.toISOString());
                          }}
                          renderInput={({inputRef,inputProps,InputProps,}) => (
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                              <Form.Control
                                ref={inputRef}
                                {...inputProps}
                                className={"input_pd"}
                                placeholder='dd-mm-yyyy'
                                value={dateTo ? format(new Date(dateTo), 'dd-MM-yyyy') : ''}
                              />
                              {InputProps?.endAdornment}
                              {dateTo && (
                                <Button variant="link" onClick={() => setDateTo(null)} className={"cross-button position-absolute"}>
                                  &#x2716;
                                </Button>
                              )}
                            </Box>
                          )}
                        />
                      </LocalizationProvider>
                    </Form.Group>
                  </Col>
                  <Col md={4} className='mb-4'>
                    <Form.Group>
                      <Form.Label>Filter By Page Type </Form.Label>
                      <Select
                        placeholder="Search & Select..."
                        name="page_type"
                        isClearable={true}
                        isSearchable={true}
                        options={pollPageTypeFilterData?.page_type}
                        getOptionLabel={(option) => option["value"]}
                        getOptionValue={(option) => option["id"]}
                        onChange={(obj) => {
                          handleOnChange('page_type', obj)
                        }}
                        value={values?.page_type || null}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4} className='mb-4'>
                    <Form.Group>
                      <Form.Label>Filter By Entity Type </Form.Label>
                      <Select
                        placeholder="Search & Select..."
                        name="entity_type"
                        isClearable={true}
                        isSearchable={true}
                        options={pollEntityTypeFilterData?.entity_types}
                        getOptionLabel={(option) => option["value"]}
                        getOptionValue={(option) => option["id"]}
                        onChange={(obj) => handleOnChange("entity_type", obj)}
                        value={values?.entity_type || null}
                        isDisabled={(values?.page_type?.value !== 'Articles') && (values?.page_type?.value !=='News')}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4} className='mb-4'>
                    <Form.Group>
                      <Form.Label>Filter By Entity Name </Form.Label>
                      <Select
                        placeholder="Search & select..."
                        name="entity_name"
                        isClearable={true}
                        isSearchable={true}
                        options={pollEntityNameFilterData?.entity_names}
                        getOptionLabel={(option) => option["value"]}
                        getOptionValue={(option) => option["id"]}
                        onChange={(obj) => handleOnChange("entity_name", obj)}
                        onInputChange={(query) => handleSearchEntityName(query)}
                        value={values?.entity_name || null}
                        isDisabled={((!values?.page_type?.show_entity_name) || (values?.page_type.value=='Articles' || values?.page_type.value=='News') && !values?.entity_type?.value)} 
                      />
                    </Form.Group>
                  </Col>
                  {/* {showError(errors, touched, "link_name")} */}
                </Row>
                <Row>
                  <Col>
                    <Form.Group>
                      <div className='manage_ranking_button_cover'>
                        <button
                          className={`exam_button ${isSearchDisabled && 'disabled_button'}`}
                          type="button"
                          onClick={handleSearch}
                          disabled={isSearchDisabled}
                        >
                          Apply Filters
                        </button>
                        <button
                          className={`exam_button ${isSearchDisabled && 'disabled_button'}`}
                          type="button"
                          onClick={handleClear}
                          disabled={isSearchDisabled}
                        >
                          Clear Filters
                        </button>
                      </div>
                    </Form.Group>
                  </Col>
                </Row>
              </Form>
            );
          }}
        </Formik>
      </div>
      {/* button to navigate => add poll panel */}

      <div style={{ display: 'flex', justifyContent: 'right', padding: '20px 0px' }}>
        <div style={{ width: 'max-content' }}>
          <Link to={"/cms/polls/manage-polls"} className={"tablestrip_list_anchor"}>
            Add Poll
          </Link>
        </div>
      </div>

      {/* Listing Table */}

      <div className={"polls_table_list_cover"}>
        <DataTable
          columns={tableCustomData}
          customStyles={CUSTOM_STYLE_PERMISSION_DATA_TABLE}
          progressPending={pollsListLoading}
          data={tableData}
          paginationPerPage={perPage}
          pagination
          paginationServer
          onChangePage={handlePageChange}
          paginationTotalRows={totalRows}
          onChangeRowsPerPage={handlePerRowsChange}
          paginationComponentOptions={{ noRowsPerPage: true }} // to hide dynamic item on page field
          paginationResetDefaultPage={resetPaginationToggle} // to reset pagination on every search
        />
      </div>

      {/* delete confirmation */}
      {open && 
        <ConfirmDelete open={open} setOpen={setOpen}/>
      }
    </>
  )
}
